import { Link } from 'react-router';

/**
 * The forum's own condensed rules — shown inline on the landing page (so a
 * new member sees them without navigating anywhere) and again at its own
 * `/guidelines` route (so the footer link, which appears on every page, has
 * somewhere real to land rather than an in-page anchor that only makes sense
 * from `/`).
 */
export function CommunityGuidelines({ standalone = false }: { standalone?: boolean }): React.JSX.Element {
  return (
    <section id="guidelines" aria-labelledby="guidelines-heading">
      {standalone && (
        <Link to="/" className="back-link">
          ← Back to home
        </Link>
      )}
      <h2 id="guidelines-heading">Community Guidelines</h2>
      <ul>
        <li>Keep discussions professional and constructive.</li>
        <li>
          Never post client personal information, account numbers, or screenshots of client
          records — this is an internal collaboration space, not a records system.
        </li>
        <li>No harassment, discrimination, or inappropriate language.</li>
        <li>Stay on topic — MortgageMAX platform, process, and product discussion.</li>
        <li>
          Posts that match certain sensitive terms are automatically held for a moderator to
          review before anyone else can see them.
        </li>
        <li>If you see something that shouldn't be here, report it rather than replying in kind.</li>
      </ul>
    </section>
  );
}
